
 <nb-card style="position:relative; width:320px;" >
              
   <nb-card-header>
            
  		<div style="display:flex; width:100%">
		        <span>Бан-лист</span>   
		         <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="closeModal()">
				<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
			</span>  
                </div>

           </nb-card-header> 
        <nb-card-body  style="padding:0; position:relative;">

	<div *ngIf="!loading; loader">
	 <table *ngIf="banList?.length" class="table  table-hover" >

		<thead >
 
		</thead>
		<tbody >
		<tr *ngFor="let item of banList">
			<td>{{item.name}}</td>
			<td><div class="btnWrapp"><div><button (click)="removeFromList(item._id, item.socialUserIdentity)"  nbButton status="primary" size="tiny">Розблокувати</button></div></div></td>
			  
		</tr>

		</tbody>
		</table>


		<div style="padding:10px; text-align:center;" *ngIf="!banList?.length">Немає заблокованих користувачів</div>


		
	</div>

	<ng-template #loader>
	    <div style="display: flex; align-self: center;">
	    <div style="margin: auto;"> 
		 <app-loader></app-loader>
	     </div>
	    </div>
	</ng-template> 

	

	 </nb-card-body>

 </nb-card>
